import { Component, OnInit } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'soft-goldschmiede',
    templateUrl: './goldschmiede.component.html',
    styleUrls: ['./goldschmiede.component.scss'],
    imports: [
        AsyncPipe,
        RouterOutlet
    ]
})
export class GoldschmiedeComponent implements OnInit {

  async ngOnInit(): Promise<void> {}
}
